module.exports = __webpack_public_path__ + "img/20191016162922360截图20191016154112415.fa694ef0.jpg";